const resources_data = [
  // {
  //   id: 'books-interview-preparation',
  //   type: 'post',
  //   text: 'We are all guilty of buying more books than the ones we can or have the strength to read. That pile kept growing, and, to me, the...',
  //   title: 'Must-Read Books for Engineers Preparing for Interviews',
  //   image: '/images/blog/put-a-limit-to-your-stack.png',
  //   date: 'May 5th, 2023',
  //   time: '12 min read',
  //   authorImage: '/images/users/miguelbemartin.jpg',
  //   authorName: 'Miguel Ángel Martín',
  //   authorDescription: 'Engineering Book Club Co-founder. Software Developer, musician and runner.',
  //   authorWebsite: 'https://josealobato.com/',
  //   authorTwitter: 'https://twitter.com/JoseALobato',
  // },
  // {
  //   id: 'book-challenge-2025',
  //   type: 'post',
  //   text: 'I love books. Going to the bookstore or the library and searching for the next thing to read is mágical. It reminds me of the days when we bought music records...',
  //   title: 'The challenge of reading 12 books in 2025',
  //   image: '/images/blog/audiobooks.jpg',
  //   date: 'Nov 19th, 2023',
  //   time: '9 min read',
  //   authorImage: '/images/users/miguelbemartin.jpg',
  //   authorName: 'Miguel Martin',
  //   authorDescription: 'Engineering Book Club Co-founder. Software Developer, musician and runner.',
  //   authorWebsite: 'https://miguelangelmartin.me/',
  //   authorTwitter: 'https://twitter.com/JoseALobato',
  // },
  {
    id: 'from-tutorial-hell-to-deep-understanding',
    type: 'post',
    text: 'We have all been there. You watch a tutorial, follow along step by step, and feel like you understand everything. Then you close the video and try to build something on your own...',
    title: 'From tutorial hell to deep understanding',
    image: '/images/blog/from-tutorial-hell-to-deep-understanding.jpg',
    date: 'Feb 20th, 2026',
    time: '8 min read',
    authorImage: '/images/users/miguelbemartin.jpg',
    authorName: 'Miguel Martin',
    authorDescription: 'Engineering Book Club Co-founder. Software Developer.',
    authorWebsite: 'https://miguelangelmartin.me/',
    authorTwitter: 'https://twitter.com/miguelbemartin',
  },
  {
    id: 'five-books-that-changed-how-i-write-code',
    type: 'post',
    text: 'Over the years I have read dozens of engineering books. Some were good, some were forgettable, and a handful completely changed the way I think about writing software...',
    title: 'Five books that changed how I write code',
    image: '/images/blog/five-books-that-changed-how-i-write-code.jpg',
    date: 'Feb 15th, 2026',
    time: '9 min read',
    authorImage: '/images/users/miguelbemartin.jpg',
    authorName: 'Miguel Martin',
    authorDescription: 'Engineering Book Club Co-founder. Software Developer.',
    authorWebsite: 'https://miguelangelmartin.me/',
    authorTwitter: 'https://twitter.com/miguelbemartin',
  },
  {
    id: 'why-engineers-should-read-books',
    type: 'post',
    text: 'In a world of blog posts, tutorials and short videos, sitting down with a full-length engineering book can feel like a commitment. But there is something uniquely valuable about...',
    title: 'Why engineers should still read books',
    image: '/images/blog/why-engineers-should-read-books.jpg',
    date: 'Feb 10th, 2026',
    time: '7 min read',
    authorImage: '/images/users/miguelbemartin.jpg',
    authorName: 'Miguel Martin',
    authorDescription: 'Engineering Book Club Co-founder. Software Developer.',
    authorWebsite: 'https://miguelangelmartin.me/',
    authorTwitter: 'https://twitter.com/miguelbemartin',
  },
  {
    id: 'how-to-read-a-technical-book-in-a-week',
    type: 'post',
    text: 'A common misconception is that reading a technical book means reading every single word from cover to cover. That approach works for novels, but for engineering books it is often the slowest path to...',
    title: 'How to read a technical book in a week',
    image: '/images/blog/how-to-read-a-technical-book-in-a-week.jpg',
    date: 'Jan 30th, 2026',
    time: '7 min read',
    authorImage: '/images/users/miguelbemartin.jpg',
    authorName: 'Miguel Martin',
    authorDescription: 'Engineering Book Club Co-founder. Software Developer.',
    authorWebsite: 'https://miguelangelmartin.me/',
    authorTwitter: 'https://twitter.com/miguelbemartin',
  },
  {
    id: 'how-to-learn-from-engineering-books',
    type: 'post',
    text: 'Reading an engineering book is not the same as reading a novel. You cannot just let the words wash over you and expect to retain the material. The best approach combines active reading with...',
    title: 'How to actually learn from engineering books',
    image: '/images/blog/how-to-learn-from-engineering-books.jpg',
    date: 'Jan 20th, 2026',
    time: '10 min read',
    authorImage: '/images/users/miguelbemartin.jpg',
    authorName: 'Miguel Martin',
    authorDescription: 'Engineering Book Club Co-founder. Software Developer.',
    authorWebsite: 'https://miguelangelmartin.me/',
    authorTwitter: 'https://twitter.com/miguelbemartin',
  },
  {
    id: 'the-case-for-rereading-engineering-books',
    type: 'post',
    text: 'Most engineers read a book once and move on to the next one. But some books deserve a second visit. The ideas that went over your head the first time might click perfectly after six months of...',
    title: 'The case for rereading engineering books',
    image: '/images/blog/the-case-for-rereading-engineering-books.jpg',
    date: 'Jan 10th, 2026',
    time: '6 min read',
    authorImage: '/images/users/miguelbemartin.jpg',
    authorName: 'Miguel Martin',
    authorDescription: 'Engineering Book Club Co-founder. Software Developer.',
    authorWebsite: 'https://miguelangelmartin.me/',
    authorTwitter: 'https://twitter.com/miguelbemartin',
  },
  {
    id: 'classic-vs-modern-engineering-books',
    type: 'post',
    text: 'Should you read The Mythical Man-Month or the latest release on microservices? The answer is not as simple as picking whichever is newer. Both classic and modern engineering books have something...',
    title: 'Classic vs modern engineering books: which should you read first?',
    image: '/images/blog/classic-vs-modern-engineering-books.jpg',
    date: 'Dec 28th, 2025',
    time: '8 min read',
    authorImage: '/images/users/miguelbemartin.jpg',
    authorName: 'Miguel Martin',
    authorDescription: 'Engineering Book Club Co-founder. Software Developer.',
    authorWebsite: 'https://miguelangelmartin.me/',
    authorTwitter: 'https://twitter.com/miguelbemartin',
  },
  {
    id: 'building-a-personal-engineering-library',
    type: 'post',
    text: 'Every engineer should have a personal library — not a massive collection, but a carefully curated shelf of books you can reach for when you need guidance on a specific topic...',
    title: 'Building your personal engineering library',
    image: '/images/blog/building-a-personal-engineering-library.jpg',
    date: 'Dec 20th, 2025',
    time: '7 min read',
    authorImage: '/images/users/miguelbemartin.jpg',
    authorName: 'Miguel Martin',
    authorDescription: 'Engineering Book Club Co-founder. Software Developer.',
    authorWebsite: 'https://miguelangelmartin.me/',
    authorTwitter: 'https://twitter.com/miguelbemartin',
  },
  {
    id: 'reading-engineering-books-as-a-team',
    type: 'post',
    text: 'Reading alone is great, but reading as a team is a multiplier. When a group of engineers reads the same book together, the discussions that follow can surface insights that no one would have...',
    title: 'The benefits of reading engineering books as a team',
    image: '/images/blog/reading-engineering-books-as-a-team.jpg',
    date: 'Dec 15th, 2025',
    time: '8 min read',
    authorImage: '/images/users/miguelbemartin.jpg',
    authorName: 'Miguel Martin',
    authorDescription: 'Engineering Book Club Co-founder. Software Developer.',
    authorWebsite: 'https://miguelangelmartin.me/',
    authorTwitter: 'https://twitter.com/miguelbemartin',
  },
  {
    id: 'about-audiobooks',
    type: 'post',
    text: 'I love books. Going to the bookstore or the library and searching for the next thing to read is mágical. It reminds me of the days when we bought music records...',
    title: 'Listening to Audiobooks vs Reading Books',
    image: '/images/blog/audiobooks.jpg',
    date: 'Nov 19th, 2023',
    time: '9 min read',
    authorImage: '/images/users/josealobato.jpg',
    authorName: 'Jose Lobato',
    authorDescription: 'Engineering Book Club Co-founder. Software Developer, musician and runner.',
    authorWebsite: 'https://josealobato.com/',
    authorTwitter: 'https://twitter.com/JoseALobato',
  },
  {
    id: 'put-a-limit-to-your-read-stack',
    type: 'post',
    text: 'We are all guilty of buying more books than the ones we can or have the strength to read. That pile kept growing, and, to me, the...',
    title: 'How to decide what to read next',
    image: '/images/blog/put-a-limit-to-your-stack.png',
    date: 'May 5th, 2023',
    time: '12 min read',
    authorImage: '/images/users/josealobato.jpg',
    authorName: 'Jose Lobato',
    authorDescription: 'Engineering Book Club Co-founder. Software Developer, musician and runner.',
    authorWebsite: 'https://josealobato.com/',
    authorTwitter: 'https://twitter.com/JoseALobato',
  },
  {
    id: 'about-read-routine',
    type: 'post',
    text: 'It seems obvious, but having a routine is the best way to read and make the most of your time reading. In the same way that a writer sits down every day to write like any...',
    title: 'How to build a reading routine',
    image: '/images/blog/about-read-routine.png',
    date: 'May 2th, 2023',
    time: '6 min read',
    authorImage: '/images/users/josealobato.jpg',
    authorName: 'Jose Lobato',
    authorDescription: 'Engineering Book Club Co-founder. Software Developer, musician and runner.',
    authorWebsite: 'https://josealobato.com/',
    authorTwitter: 'https://twitter.com/JoseALobato',
  },
  {
    id: 'take-notes-in-your-books',
    type: 'post',
    text: 'When I was a kid, writing in your books was unacceptable. I remember teachers making me feel like I was destroying my books. Not anymore! I love commenting on my books,...',
    title: 'How to take notes while reading a book',
    image: '/images/blog/taking-notes-in-your-books.jpg',
    date: 'April 12th, 2023',
    time: '8 min read',
    authorImage: '/images/users/josealobato.jpg',
    authorName: 'Jose Lobato',
    authorDescription: 'Engineering Book Club Co-founder. Software Developer, musician and runner.',
    authorWebsite: 'https://josealobato.com/',
    authorTwitter: 'https://twitter.com/JoseALobato',
  },
];

export { resources_data };
